import i18n from '@/lib/i18n';
import { manageError } from '@/lib/manage-error.ts';
import { DeviceService } from '@/service/DeviceService';
import { useDeviceStore } from '@/store/DeviceStore';
import { DeviceRegistry, MediaDeviceKind } from 'intermind';
import { DeviceRegistryListener } from 'mind-sdk-web';

export class DeviceRegistryEventListener implements DeviceRegistryListener {
  private readonly deviceService: DeviceService;

  constructor(deviceService: DeviceService) {
    this.deviceService = deviceService;
  }

  async onDeviceRegistryChanged(registry: DeviceRegistry): Promise<void> {
    if (!registry || !this.deviceService) {
      return;
    }

    try {
      // Update available devices
      this.deviceService.setupAvailableDevices();

      // Select default devices
      await this.deviceService.useDefaultDevices();
    } catch (error) {
      manageError(error, i18n.t('events.deviceRegistry.errorSettingUpDevices'));
    }
  }

  async onDevicePermissionChanged(deviceKind: MediaDeviceKind, isDenied: boolean): Promise<void> {
    switch (deviceKind) {
      case MediaDeviceKind.Microphone:
        useDeviceStore.getState().setMicrophoneDenied(isDenied);
        break;
      case MediaDeviceKind.Camera:
        useDeviceStore.getState().setCameraDenied(isDenied);
        break;
    }
  }
}
